export const LOGIN_ROUTE = "/login";
export const REGISTRATION_ROUTE = "/registration";
export const FILE_ROUTE = "/file";
export const TRACKS_ROUTE = "/tracks";
export const UPLOAD_ROUTE = "/upload";
export const MAIN_ROUTE = "/base";
export const USERS_ROUTE = "/users";
export const REPORT_ROUTE = "/report";
export const REPORTS_ROUTE = "/reports";
export const CONTRACTS_ROUTE = "/contracts";
export const ROLES = [
    "ADMIN",
    "USER",
    "ARTIST"
];

export const OWNER_TYPE = [
    {label: "Авторские", value: "COPYRIGHT"},
    {label: "Смежные", value: "RELATED"}
];

export const PARSE_FIELDS = {
    "authorContentCost": "Авторские ст-ть ед контента",
    "authorLicensePrize": "Авторские сумма",
    "contentProvider": "Контент-Провайдер",
    "downloads": "Кол-во скачиваний",
    "platform": "Платформа",
    "relatedContentCost": "Смежные ст-ть ед контента",
    "relatedLicensePrize": "Смежные сумма",
    "singer": "Исполнитель",
    "songName": "Трек",
};